import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export function CategoryChip({ category }) {
  const isOriginal = category === "original";
  return (
    <span
      className={`rounded-full px-3 py-1 text-[10px] font-mono uppercase tracking-[0.18em] ${
        isOriginal ? "bg-orange text-cream" : "bg-blue text-cream"
      }`}
    >
      {isOriginal ? "Original" : "Service"}
    </span>
  );
}

export default function ProjectCard({ p, i = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.65, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      <Link to={`/projects/${p.slug}`} data-testid={`project-card-${p.slug}`} className="group block">
        <div className="relative overflow-hidden rounded-2xl border border-border transition-shadow duration-500 group-hover:shadow-[0_20px_60px_-20px_rgba(255,90,31,0.35)]">
          <div className="aspect-[4/3] w-full overflow-hidden bg-cream2 dark:bg-card">
            <img
              src={p.poster}
              alt={p.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent opacity-90" />
          <div className="absolute left-4 top-4 flex gap-2">
            <CategoryChip category={p.category} />
            <span className="rounded-full bg-cream/90 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.18em] text-ink">
              {p.type} · {p.year}
            </span>
          </div>
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-5">
            <div>
              <h3 className="font-display text-xl font-bold tracking-tight text-cream sm:text-2xl">{p.title}</h3>
              <p className="mt-1 text-xs font-mono uppercase tracking-[0.18em] text-cream/70">
                {p.client ? p.client : p.director ? `Dir. ${p.director}` : ""}
              </p>
            </div>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-cream/40 text-cream transition-all duration-300 group-hover:border-orange group-hover:bg-orange">
              <ArrowUpRight size={18} />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
